import {Component, EventEmitter, Input, Output} from '@angular/core';
import {NgClass, NgFor} from "@angular/common";
import {STEP_STATUS} from "../../../models/enums";
import {PlannerRepository} from "../../../repositories/planner.repository";
import {ActivatedRoute} from "@angular/router";
import {environment} from "../../../../environments/environment";
import {NotificationService} from "../../../services/notification.service";

@Component({
  selector: 'app-available-plugins',
  standalone: true,
  imports: [NgFor, NgClass],
  templateUrl: './available-plugins.component.html',
  styleUrl: './available-plugins.component.css'
})
export class AvailablePluginsComponent {
  toolingId: string | null = "";
  @Input() step: any;
  @Output() loadTooling: EventEmitter<void> = new EventEmitter<void>();

  constructor(private plannerRepository: PlannerRepository,private route: ActivatedRoute, private notificationService: NotificationService) {}

  async ngOnInit(): Promise<void> {
    this.route.paramMap.subscribe(params => {
      this.toolingId = params.get('plannerId');
    });
    if(environment.standalone){
      this.plannerRepository.setUrl(environment.standaloneServiceUrlForPlanner);
    }
    else {
      this.plannerRepository.setUrl(environment.serviceUrl+environment.plannerServiceUrl);
    }
  }
  toggleSelect(i: any,stepStatus: STEP_STATUS) {
    if(stepStatus == STEP_STATUS.USER_PENDING) {
      this.step.action.plugins[i].enabled = !this.step.action.plugins[i].enabled;
    }
  }
  hasEnabledPlugin(plugins: any[]): boolean {
    return plugins.some(plugin => plugin.enabled === true);
  }
  next(){

    if(this.toolingId && this.hasEnabledPlugin(this.step.action.plugins)) {
      this.step.stepStatus="USER_FINALIZED";
      this.plannerRepository.patchToolingStep(this.toolingId, this.step.toolingStepId, this.step).subscribe(
        async (toolingStepPatchResponse: any) => {
          console.log(toolingStepPatchResponse);
          this.loadTooling.emit();
        }
      );
    }
    else {
        this.notificationService.showWarning("Warning",'planner.noPlugin')
    }
  }
  protected readonly STEP_STATUS = STEP_STATUS;
}
